import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleSection() {
  const displayArticles = articles.slice(0, 4);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">最新资讯</h2>
          <p className="text-sm text-foreground-600 mt-2">电影资讯、追剧指南、平台动态一手掌握</p>
        </div>
        <Link
          to="/article/why-bale-video-is-best-alternative"
          className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
        >
          查看全部
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {displayArticles.map((article) => (
          <Link
            key={article.id}
            to={`/article/${article.slug}`}
            className="group bg-background-50 rounded-lg border border-background-200 overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer"
          >
            <div className="aspect-[16/9] overflow-hidden bg-background-200">
              <img
                src={article.image}
                alt={article.title}
                title={article.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                loading="lazy"
              />
            </div>
            <div className="p-4">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-xs bg-accent-100 text-accent-800 px-2 py-0.5 rounded-full font-medium">{article.category}</span>
                <span className="text-xs text-foreground-500">{article.date}</span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors mb-2">
                {article.title}
              </h3>
              <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed">
                {article.excerpt}
              </p>
              <div className="flex items-center gap-3 mt-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {article.views}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-user-line"></i>
                  {article.author}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="mt-6 text-center sm:hidden">
        <Link
          to="/article/why-bale-video-is-best-alternative"
          className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium whitespace-nowrap cursor-pointer"
        >
          查看全部资讯
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}